/** Price-action setups, zones, setup score and FX news. Each key must exist in both languages. */
export const setup = {
  en: {

    "fxn.dir.bullish": "bullish",
    "fxn.dir.bearish": "bearish",
    "fxn.dir.neutral": "neutral",
    "fxn.interp": "{cur} {curDir} ({rule}) → {pair} {pairDir}",
    "fxn.interpSentiment": "Headline tone → {pair} {pairDir}",
    "fxn.rule.strength": "currency strength",
    "fxn.rule.weakness": "currency weakness",
    "fxn.rule.hawkish": "hawkish central bank",
    "fxn.rule.dovish": "dovish central bank",
    "fxn.rule.inflationHot": "inflation above expectations",
    "fxn.rule.inflationCool": "inflation cooling",
    "fxn.rule.dataStrong": "strong data",
    "fxn.rule.dataWeak": "weak data",
    "fxn.rule.safeHaven": "safe-haven demand",
    "fxn.react.PENDING": "Reaction pending — no bar has closed since publication",
    "fxn.react.CONFIRMS": "Price moved {move} — the market reaction agrees with the expectation",
    "fxn.react.CONTRADICTS": "Price moved {move} — the market reaction contradicts the expectation",
    "fxn.react.NO_REACTION": "No significant reaction ({move})",
    "fxn.react.UNKNOWN": "Reaction unknown (no price data around the publication)",
  },
  de: {

    "fxn.dir.bullish": "bullish",
    "fxn.dir.bearish": "bearish",
    "fxn.dir.neutral": "neutral",
    "fxn.interp": "{cur} {curDir} ({rule}) → {pair} {pairDir}",
    "fxn.interpSentiment": "Tonlage der Schlagzeile → {pair} {pairDir}",
    "fxn.rule.strength": "Währungsstärke",
    "fxn.rule.weakness": "Währungsschwäche",
    "fxn.rule.hawkish": "restriktive Notenbank",
    "fxn.rule.dovish": "lockere Notenbank",
    "fxn.rule.inflationHot": "Inflation über Erwartung",
    "fxn.rule.inflationCool": "nachlassende Inflation",
    "fxn.rule.dataStrong": "starke Daten",
    "fxn.rule.dataWeak": "schwache Daten",
    "fxn.rule.safeHaven": "Nachfrage nach sicheren Häfen",
    "fxn.react.PENDING": "Reaktion ausstehend — seit der Veröffentlichung ist noch keine Periode abgeschlossen",
    "fxn.react.CONFIRMS": "Kurs bewegte sich {move} — die Marktreaktion bestätigt die Erwartung",
    "fxn.react.CONTRADICTS": "Kurs bewegte sich {move} — die Marktreaktion widerspricht der Erwartung",
    "fxn.react.NO_REACTION": "Keine deutliche Reaktion ({move})",
    "fxn.react.UNKNOWN": "Reaktion unbekannt (keine Kursdaten um die Veröffentlichung)",
  },
};
